import React from 'react';
import VanGoghFeature from '../components/VanGoghFeature';
import '../components/VanGoghFeature.css';

const About = () => {
  return (
    <div>
      <VanGoghFeature />
    </div>
  );
};

export default About;